import { usePunditUserContext } from "@/react/contexts";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";

export const useIsEoYRecapEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.cms_builder_eoy_recap_2025_enabled);
};

export const useIsEoYRecapEnabledForMembers = () => {
  const { currentCommunitySettings, currentCommunityMember } =
    usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.eoy_recap_enabled_for_members &&
      !isCommunityAdmin(currentCommunityMember),
  );
};
